<template>
  <div>
    <template v-if="loading.view">
      <Spinner></Spinner>
    </template>
    <template v-else>
      <template v-if="estaAnulado">
        <div class="alert alert-danger text-white">
          <p class="m-0">
            Anulado el {{ anulado.fecha | date }}. Motivo: {{ anulado.motivo }}.
            Realizado por: {{ anulado.author }}
          </p>
        </div>
      </template>

      <ValidationObserver ref="form">
        <ComprobanteNota v-if="emitirNota || esNota"></ComprobanteNota>
        <ComprobanteComprobante></ComprobanteComprobante>
        <ComprobanteCliente></ComprobanteCliente>

        <h6><strong>Datos del Servicio</strong></h6>
        <ComprobanteTable2></ComprobanteTable2>

        <br />

        <div class="text-right">
          <template v-if="!disableGenerarComprobante">
            <button
              class="btn btn-primary"
              @click="onGenerar"
              :disabled="loading.save"
            >
              Generar Comprobante
            </button>
          </template>
          <template v-else>
            <button
              v-if="initialModo == 2"
              class="btn btn-outline-primary mr-2"
              @click="onNuevo"
            >
              Nuevo Comprobante
            </button>
            <button class="btn btn-outline-secondary" @click="onImprimir">
              Imprimir Comprobante
            </button>
          </template>
        </div>
      </ValidationObserver>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import ComprobanteNota from "./ComprobanteNota.vue";
import ComprobanteCliente from "./ComprobanteCliente.vue";
import ComprobanteComprobante from "./ComprobanteComprobante.vue";
import ComprobanteTable2 from "./ComprobanteTable2.vue";
import Spinner from "../../shared/components/Spinner.vue";
import comprobantePdf from "../pdfs/comprobantePdf";

export default {
  components: {
    Spinner,
    ComprobanteTable2,
    ComprobanteComprobante,
    ComprobanteCliente,
    ComprobanteNota
  },
  props: {
    initialModo: {
      type: Number,
      default: 2
    },
    initialSerie: {
      type: String,
      default: ""
    },
    initialNota: {
      type: Object,
      default: () => ({})
    },
    initialComprobante: {
      type: Object,
      default: () => ({})
    },
    initialCliente: {
      type: Object,
      default: () => ({})
    },
    initialAnulado: {
      type: Object,
      default: () => ({})
    },
    facturado: {
      type: null,
      default: null
    },
    initialItems: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState("comprobante2", {
      nota: state => state.nota,
      comprobante: state => state.comprobante,
      cliente: state => state.cliente,
      anulado: state => state.anulado,
      items: state => state.items
    }),
    ...mapGetters("comprobante2", [
      "loading",
      "serie",
      "estaAnulado",
      "estaFacturado",
      "emitirNota",
      "esNota",
      "esNotaCredito",
      "esModoVista",
      "esModoManual",
      "tipoIgv",
      "esOtroCliente",
      "monedaSelected",
      "numeroDoc",
      "agenciaSelected",
      "comprobanteTipoDocSelected",
      "tipoPagoSelected",
      "containers",
      "total",
      "modo",
      "disableGenerarComprobante",
      "getComprobanteNumeroDoc",
      "getComprobanteTipoDoc",
      "getComprobanteSerie",
      "getComprobanteAsociadoTipoDoc",
      "getComprobanteAsociadoNumeroDoc",
      "getComprobanteAsociadoSerie"
    ])
  },
  async created() {
    try {
      const response = await this.axios.get("/comprobantes/nuevo2", {
        params: {
          serie: this.initialSerie
        }
      });

      const { numero, notaNumeroDoc, ...containers } = response.data.content;

      this.$store.dispatch("comprobante2/load", {
        modo: this.initialModo,
        nota: {
          numeroDoc: notaNumeroDoc,
          ...this.initialNota
        },
        comprobante: {
          fechaEmision: this.$dayjs().format("YYYY-MM-DD"),
          numeroDoc: numero,
          ...this.initialComprobante
        },
        cliente: {
          ...this.initialCliente
        },
        anulado: {
          ...this.initialAnulado
        },
        items: this.initialItems,
        containers: {
          ...containers,
          facturado: this.facturado
        }
      });
    } catch (error) {
      console.error({ error });
    }
  },

  watch: {
    "loading.view"() {
      const vm = this;
      vm.$nextTick(() => {
        vm.onLoaded();
      });
    }
  },
  methods: {
    onLoaded() {
      this.$watch("nota.tipoDoc", this.onChangeNotaTipoDoc);
      this.$watch("comprobante.tipoDoc", this.onChangeComprobanteTipo);
      this.$watch("cliente.agencia", this.onChangeClienteAgencia);
      this.$watch("cliente.cambiarPorPasajero", this.onCambiarPorPasajero);
    },
    async onChangeNotaTipoDoc(val) {
      this.$store.dispatch("comprobante2/fetchNotaNumeroDoc", val);
    },
    async onChangeComprobanteTipo(val) {
      this.$store.dispatch("comprobante2/fetchComprobanteNumeroDoc", val);
    },
    onChangeClienteAgencia(val) {
      this.$store.dispatch("comprobante2/changeClienteAgencia", val);
    },
    onCambiarPorPasajero(val) {
      this.$store.dispatch("comprobante2/cambiarPorPasajero", val);
    },
    async onGenerar() {
      let validated = await this.$refs.form.validate();

      if (!validated) {
        this.$toast.fire({
          icon: "warning",
          title: "Revise y verifique los campos marcados en rojo"
        });
        return;
      }

      if (this.items.length < 1) {
        this.$toast.fire({
          icon: "warning",
          title: "Ingresa por lo menos 1 item"
        });
        return;
      }

      const result = await this.$store.dispatch("comprobante2/startGenerar");

      if (result) {
        this.$toast.fire({ icon: "success", title: "Operación Exitosa" });
        this.$emit("facturar");
      }
    },
    onNuevo() {
      window.location.reload();
    },
    onImprimir() {
      const items = [...this.items].map(item => {
        return {
          descripcion: item?.descripcion || "",
          cantidad: {
            text: item?.cantidad || "",
            alignment: "right"
          },
          precioUnitario: {
            text: item?.precioUnitario || "",
            alignment: "right"
          },
          valorUnitario: {
            text: item.valorUnitario,
            alignment: "right"
          },
          igv: {
            text: item.igv,
            alignment: "right"
          },
          subtotal: {
            text: item.subtotal,
            alignment: "right"
          },
          total: {
            text: item.total,
            alignment: "right"
          }
        };
      });

      comprobantePdf({
        header: {
          tipo: this.getComprobanteTipoDoc,
          numero: this.getComprobanteNumeroDoc,
          serie: this.getComprobanteSerie,
          comprobanteAsociadoTipoDoc: this.getComprobanteAsociadoTipoDoc,
          comprobanteAsociadoNumeroDoc: this.getComprobanteAsociadoNumeroDoc,
          comprobanteAsociadoSerie: this.getComprobanteAsociadoSerie,
          anulacionFecha: this.estaAnulado
            ? this.$options.filters.date(this.anulado.fecha)
            : "",
          anulacionMotivo: this.estaAnulado ? this.anulado.motivo : "",
          anulacionAutor: this.estaAnulado ? this.anulado.author : "",
          denominacion: this.cliente.denominacion,
          fechaEmision: this.$options.filters.date(
            this.comprobante.fechaEmision
          ),
          email: this.cliente.email || "",
          direccion: this.cliente.direccion,
          moneda: this.monedaSelected.sigla,
          numeroDoc: this.cliente.numeroDoc,
          qr: this.containers.facturado?.qr || "",
          enlaceComprobante: this.containers.facturado?.enlaceComprobante || "",
          enlacePdf: this.containers.facturado?.enlacePdf || "",
          enlaceXml: this.containers.facturado?.enlaceXml || "",
          enlaceCdr: this.containers.facturado?.enlaceCdr || "",
          observaciones: this.comprobante.observaciones || "",
          pagoTipo: this.tipoPagoSelected.nombre,
          pagoDias: this.comprobante.pagoDias || ""
        },
        items: items,
        totales: {
          gravada: this.total.gravada,
          sinIgv: this.total.sinIgv,
          igv: this.total.igv,
          gratuita: this.total.gratuita,
          total: this.total.total,
          letras: this.containers.facturado?.totalLetras || ""
        }
      });
    }
  },
  beforeDestroy() {
    console.log("beforeDestroy");
    this.$store.commit("comprobante2/clear");
  }
};
</script>

<style></style>
